"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isActiveSpectrum = exports.getActiveSpectraAsObject = void 0;
const getActiveSpectra_1 = require("./getActiveSpectra");
function getActiveSpectraAsObject(state) {
    const activeSpectra = (0, getActiveSpectra_1.getActiveSpectra)(state);
    if (!activeSpectra || activeSpectra?.length === 0)
        return null;
    const activeSpectraObject = {};
    for (const activeSpectrum of activeSpectra) {
        activeSpectraObject[activeSpectrum.id] = activeSpectrum.index;
    }
    return activeSpectraObject;
}
exports.getActiveSpectraAsObject = getActiveSpectraAsObject;
function isActiveSpectrum(activeSpectra, id) {
    return !!(activeSpectra && id in activeSpectra);
}
exports.isActiveSpectrum = isActiveSpectrum;
